export default __webpack_public_path__ + "static/media/calenderIcon-717214f7ca6405173d5c29afe4a699a9.png";